<template>
  <div>
    <v-dialog v-model="dialog" width="900" max-width="800" v-on:click:outside="closeDialog()"
      v-on:keydown.esc="closeDialog()">
      <v-card elevation="0" style="border-top: 10px solid #095797">
        <v-card-title>
          {{ titreDialogue }}
        </v-card-title>
        <v-card-text class="pb-0">
          <v-row>
            <!-- Radio buttons CSS de l'Estrie-Montérégie, CSS autre que Estrie-Montérégie et Établissement privé -->
            <v-col cols="12">
              <div>
                <v-radio-group v-model="radioGroup" row v-on:change="verifierSiDisponible"
                  class="justifierRadioGroupOrganismes" style="max-width:96%;margin:auto">
                  <v-radio
                    :label="$t('dialogInscription.radioButtonCssMonteregieEstrie', { nomRegion: appStore.nomRegion })"
                    :value="CSSMonteregieEstrie"></v-radio>
                  <v-radio
                    :label="$t('dialogInscription.radioButtonCssAutreQueMonteregieEstrie', { nomRegion: appStore.nomRegion })"
                    :value="AutreCSS"></v-radio>
                  <v-radio :label="$t('dialogInscription.radioButtonEtablissementPrive')" :value="EtablissementPrive"
                    class="mr-0"></v-radio>
                </v-radio-group>
              </div>
            </v-col>
            <v-col cols="12" class="text-center" v-if="!estExterne && radioGroup != null">
              <!-- Sélection de l'établissement (ex: CSP ou csdhr) -->
              <v-autocomplete :items="inscriptionStore.listeCssMinimise" v-model="cssSelectionne"
                :item-text="(item) => item.nom" style="max-width:96%;margin:auto" dense outlined return-object
                :placeholder="$t('dialogInscription.selectPlaceholder')" v-on:change="verifierSiDisponible()"
                hide-details="auto">
              </v-autocomplete>
            </v-col>

            <!-- Message d'offre des cours en présentiel  -->
            <v-col cols="12">
              <div
                v-if="inscriptionStore.urlPlateforme != null && inscriptionStore.urlPlateforme != '-1' && inscriptionStore.urlPlateforme != ''">
                <v-card-text class="py-0">
                  {{ this.$tc("dialogInscription.messageCoursPresentiel") }}
                  <a target="_blank" style="font-weight: 600" :href="inscriptionStore.urlPlateforme">{{
                    inscriptionStore.urlPlateforme }}</a>{{ this.$tc("dialogInscription.AccederOffreLigne") }}
                </v-card-text>
              </div>

              <!-- Checkbox scolarisé maison -->
              <v-checkbox :label="$t('dialogInscription.checkboxScolarisation')" v-model="estScolariseMaison"
                v-if="!estExterne && cssSelectionne != null" v-on:change="validerEnfantScolariserMaison()" class="pl-3">
              </v-checkbox>

              <v-card-text v-if="!inscriptionStore.peutSinscrire" style="color: #ff5252" class="pa-0 text-right">
                <div v-html="inscriptionStore.erreurInscription">
                </div>
              </v-card-text>
            </v-col>
          </v-row>
          <v-col class="text-right">
            <div>
              <!--Btn annuler-->
              <v-btn outlined v-on:click="closeDialog()" style="color: #095797; min-height: 48px">
                {{ $t("dialogInscription.btnAnnuler") }}
              </v-btn>

              <!--Btn continuer-->
              <v-btn :href="appStore.modele.urlBase + '/#/Boutique'" style="
                background-color: #095797;
                border-color: #095797;
                color: white !important;
                min-height: 48px;
              " :disabled="(cssSelectionne == null && !inscriptionStore.peutSinscrire) || !inscriptionStore.peutSinscrire"
                class="ml-4">
                {{ $t("dialogInscription.btnContinuer") }}
              </v-btn>
            </div>
          </v-col>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import useAppStore from '@/store/appStore';
import useInscriptionStore from '@/store/inscriptionStore';
import { InscriptionCSS } from '@/outils/Enum';
import csqcOutilsCoursEte from '@/outils/CSQCOutilsCoursEte';
import EleveInscriptionAjax from '@/services/EleveInscriptionAjax';

const racineLocalStorage = 'csqc_coursEte';
const localStorageCssId = '_CSSId';
const selectionRadioButtonLocalStorage = '_selectionInscription';
const selectionScolarisationMaisonLocalStorage = '_scolarisationMaison';

export default {
  name: 'InscriptionDialog',
  setup() {
    const appStore = useAppStore();
    const inscriptionStore = useInscriptionStore();

    return { appStore, inscriptionStore };
  },
  data() {
    return {
      dialog: false,
      radioGroup: InscriptionCSS.CSSMonteregieEstrie,
      CSSMonteregieEstrie: InscriptionCSS.CSSMonteregieEstrie,
      AutreCSS: InscriptionCSS.AutreCSS,
      EtablissementPrive: InscriptionCSS.EtablissementPrive,
      estScolariseMaison: false,
      cssSelectionne: null,
      messageAvertissementScolarisation: {
        title: this.$t('dialogInscription.TitrePopupScolarisation'),
        // eslint-disable-next-line max-len
        body: this.$t('dialogInscription.MessageAvertissementPopupScolarisation', { nomRegion: this.appStore.nomRegion, anneePrecedente: this.appStore.modele.anneeEnSeptembre, anneeCourante: this.appStore.modele.anneeEnSeptembre + 1 }),
      },
      titreDialogue: '',
    };
  },
  computed: {
    estExterne() {
      if (
        this.radioGroup === InscriptionCSS.AutreCSS ||
        this.radioGroup === InscriptionCSS.EtablissementPrive
      ) {
        return true;
      } if (this.radioGroup === InscriptionCSS.CSSMonteregieEstrie || (this.radioGroup === InscriptionCSS.CSSMonteregieEstrie && this.estScolariseMaison)) {
        return false;
      }
      return null;
    },
  },
  methods: {
    async initialiser() {
      EleveInscriptionAjax.obtenirListeCssMinimise().then(async (data) => {
        this.inscriptionStore.listeCssMinimise = data;

        const valeurSelectionInscription = localStorage.getItem(racineLocalStorage + selectionRadioButtonLocalStorage); // RadioButton
        const valeurCSSId = localStorage.getItem(racineLocalStorage + localStorageCssId);

        if (valeurSelectionInscription != null && valeurSelectionInscription !== '') {
          this.radioGroup = parseInt(valeurSelectionInscription);
          if (this.radioGroup === InscriptionCSS.CSSMonteregieEstrie && (valeurCSSId != null || valeurCSSId !== '')) {
            const valeurCssSelectionne = this.obtenirCssSelectionneLocalStorage();
            this.estScolariseMaison = csqcOutilsCoursEte.EstScolariseMaison();
            this.cssSelectionne = valeurCssSelectionne;

            // On fait une validation par défaut pour afficher si la personne peut continuer ou non
            await this.verifierSiDisponible();
          }
        }
      });
    },
    reinitialiserValeurs() {
      this.inscriptionStore.peutSinscrire = false;
      this.inscriptionStore.urlPlateforme = '';
      this.inscriptionStore.erreurInscription = '';
    },

    async ouvrirDialog() {
      this.dialog = true;
      const valeurSelectionInscription = localStorage.getItem(racineLocalStorage + selectionRadioButtonLocalStorage); // RadioButton
      const valeurCSSId = localStorage.getItem(racineLocalStorage + localStorageCssId);

      this.reinitialiserValeurs();

      if (valeurSelectionInscription != null && valeurSelectionInscription !== '') {
        this.radioGroup = parseInt(valeurSelectionInscription);
        if (this.radioGroup === InscriptionCSS.CSSMonteregieEstrie && (valeurCSSId != null || valeurCSSId !== '')) {
          const valeurCssSelectionne = this.obtenirCssSelectionneLocalStorage();
          this.estScolariseMaison = csqcOutilsCoursEte.EstScolariseMaison();
          this.cssSelectionne = valeurCssSelectionne;
          // On fait une validation par défaut pour afficher si la personne peut continuer ou non
        }
        await this.verifierSiDisponible();
      }
    },
    obtenirCssSelectionneLocalStorage() {
      const valeurCssIdLocalStorage = localStorage.getItem(racineLocalStorage + localStorageCssId);
      return this.inscriptionStore.listeCssMinimise.find((x) => x.cssId === valeurCssIdLocalStorage);
    },
    closeDialog() {
      if (this.cssSelectionne != null) {
        this.cssSelectionne = null;
        localStorage.removeItem(racineLocalStorage + selectionScolarisationMaisonLocalStorage);
        localStorage.removeItem(racineLocalStorage + localStorageCssId);
      }
      this.reinitialiserValeurs();
      this.dialog = false;
    },
    async validerEnfantScolariserMaison() {
      // Scolarisé à la maison
      if (this.estScolariseMaison) {
        const message = {
          title: this.$t('dialogInscription.TitrePopupScolarisation'),
          body: this.$t(
            // eslint-disable-next-line max-len
            'dialogInscription.MessageAvertissementPopupScolarisation', { nomRegion: this.appStore.nomRegion, anneePrecedente: this.appStore.modele.anneeEnSeptembre, anneeCourante: this.appStore.modele.anneeEnSeptembre + 1 },
          ),
        };
        this.$dialog
          .confirm(message, { loader: true })
          .then((dialog) => {
            this.estScolariseMaison = true;
            localStorage.setItem(
              racineLocalStorage + selectionScolarisationMaisonLocalStorage,
              true,
            );
            dialog.close();
          })
          .catch(async () => {
            this.estScolariseMaison = false;
            localStorage.setItem(
              racineLocalStorage + selectionScolarisationMaisonLocalStorage,
              false,
            );
            await this.verifierSiDisponible(); // Remettre le check vue que le catch arrête le processus
          });
      } else {
        this.estScolariseMaison = false;
        localStorage.setItem(
          racineLocalStorage + selectionScolarisationMaisonLocalStorage,
          false,
        );
      }
      await this.verifierSiDisponible();
    },
    async verifierSiDisponible() {
      await this.inscriptionStore.verifierSiDisponible(this.radioGroup, this.cssSelectionne, this.estScolariseMaison, this.inscriptionStore.listeBlocOrganisme);
    },
  },
  async created() {
    await this.initialiser();

    // eslint-disable-next-line max-len
    this.titreDialogue = this.$t('dialogInscription.dialogTitle', { anneePrecedente: this.appStore.modele.anneeEnSeptembre, anneeCourante: this.appStore.modele.anneeEnSeptembre + 1 });
  },
};
</script>

<style scoped>
.justifierRadioGroupOrganismes::v-deep .v-input--radio-group__input {
  justify-content: space-between;
}
</style>
